export let reset = {
	cnpj: '',
	cnpj_matriz: '',
	razao_social: '',
	tipo_empresa: 'sede',
	tipo_de_cliente: 6,
	tipo_de_contrato: 'avulso',
	origem_de_cliente: 'sms',
	regiao: 'RB',
	tags: [],
	endereco: {
		logradouro: '',
		complemanto: '',
		bairro: '',
		cidade: '',
		cep: '',
		estado: '',
	},
	telefones: {
		fixo: '',
		celular: '',
		outros: '',
	},
	documentos: {
		ie: '',
		im: '',
		cnae: '',
		cipa: '',
		data_doc: '',
	},
	contato: '',
	representates: [],
};
export let reset_representante = {
	nome: '',
	qual: '',
	cpf: '',
	rg: '',
	email: '',
	telefone: '',
	endereco: '',
	estado_civil: '',
	naturalidade: '',
	opened: false,
};



// WEBPACK FOOTER //
// ./src/components/cadastros/customers/reset.js